import { baseAPIUrl } from "lib/config";

export const resolveApiUrl = (endpoint: string): string => {
  if (endpoint && endpoint.startsWith("http")) {
    return `/${endpoint}`;
  }
  return `${baseAPIUrl}/${endpoint}`;
};
